// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__14m8Y","vLegacy":"SelectSecondary_vLegacy__1v-oj","error":"SelectSecondary_error__3jJG3","disabled":"SelectSecondary_disabled__3dAUh"};